export enum EnumLeadType {
    Compulsory = 1,
    Optional = 2
}